import mapboxgl from 'mapbox-gl';
var apiKey = 'pk.eyJ1IjoiZG9taW5pazE5OTciLCJhIjoiY2tyMGk0ODBtMWJmeDJvbnhiNGp0Y2FlciJ9.bedl3MDq3j9cUekZT_wZrg';
export var initMapboxForContactPage = function initMapboxForContactPage() {
  // Get coords
  var coords = document.querySelector('.contact-map__coords');

  if (!coords) {
    return;
  }

  var coordX = coords.getAttribute('data-coord-x');
  var coordY = coords.getAttribute('data-coord-y'); // Main point

  var mapCenter = [coordY, coordX];
  console.log(mapCenter); // Init mapbox

  mapboxgl.accessToken = apiKey;
  var map = new mapboxgl.Map({
    container: 'contact-map',
    style: 'mapbox://styles/mapbox/light-v10',
    zoom: 10,
    center: mapCenter
  });
  map.addControl(new mapboxgl.NavigationControl()); // create a HTML element for each feature

  var el = document.createElement('div');
  el.className = 'marker';
  new mapboxgl.Marker(el).setLngLat(mapCenter).addTo(map); // const marker = new mapboxgl.Marker().setLngLat(mapCenter).addTo(map);
};